import React from 'react'
import ModalCustom from '../../UI/modal'
import { Form } from 'react-bootstrap'
import ThInputSelect from '../../forms/th-input-select'
import ThInputText from '../../forms/th-input-text'
import Button from '../../UI/button'

type Props = {
	show: boolean
	handleClose: () => void
}

const SendInvitationModal = ({show, handleClose}: Props) => {
	const [selectedTrip, setSelectedTrip] = React.useState<string>('')
	const [inviteeEmail, setInviteeEmail] = React.useState<string>('')
	const [invitationRole, setInvitationRole] = React.useState<string>('')
	return (
		<ModalCustom show={show} onHide={handleClose} title='Send Invitation'>
			<Form>
				<ThInputSelect label='Select The Trip' required value={selectedTrip} options={[{label: 'Trip 1', value: 'trip-1'}, {label: 'Trip 2', value: 'trip-2'}, {label: 'Trip 3', value: 'trip-3'}]} onChange={setSelectedTrip}></ThInputSelect>
				<ThInputText label='Invitee Email' required value={inviteeEmail} onChange={setInviteeEmail}/>
				<ThInputSelect label='Invitation Role' required value={invitationRole} options={[{label: 'Admin', value: 'admin'}]} onChange={setInvitationRole}></ThInputSelect>
				<Button className='mx-auto' px={50} variant='primary'>
					Send
				</Button>
			</Form>
		</ModalCustom>
	)
}
export default SendInvitationModal